import { Link } from "react-router-dom";
import { PageLayout, PageBody, BookNowButton } from "@/components/site/PageLayout";

const PACKAGES = [
  {
    name: "Premium Wash",
    price: "$ 500.00",
    desc: "Wash hull, clean gutter tracks, clean windows, remove mildew from seats, clean cushions, clean compartments plus condition seats and cushions.",
  },
  {
    name: "Premium Wash & Wax",
    price: "$ 600.00",
    desc: "Same as Premium Wash, plus wax smooth gelcoat on hull and topside. This does NOT include barnacle removal or the chine) Our Polymer wax typically lasts 3 months in exposed conditions.",
  },
  {
    name: "Premium Wash, Compound & Wax",
    price: "$ 800.00",
    desc: "Same as Premium Wash & Wax, plus Compound and Wax all gelcoat surfaces. This does NOT include barnacle removal or the chine) Our Polymer wax typically lasts 3 months in exposed conditions.",
  },
  {
    name: "Premium Wash, Compound & Sealant",
    price: "$ 875.00",
    desc: "Same as Premium WASH & WAX, plus Compound and apply sealant to all gelcoat surfaces. This does NOT include barnacle removal or the chine. Our Polymer Sealant typically lasts 10 – 11 months in exposed conditions.",
  },
  {
    name: "Wash, Compound & Wax (exterior only)",
    price: "$ 23.00 / ft.",
    desc: "Compound & wax hull and gunwale. Basic wash included. (Does not include interior buffing or waxing.)",
  },
  {
    name: "5 Years Ceramic Coatings",
    price: "$ 50.00 / hour",
    desc: "Premium Wash, Polish and Apply Ceramic Coating",
  },
];

export default function BoatPage() {
  return (
    <PageLayout
      eyebrow="Boats"
      title="Boat detailing"
      titleAccent="packages"
      intro="For boats under 25 feet, see packages below (all packages below are customizable)."
    >
      <PageBody>
        <p className="text-slate-300">
          For boats over 25 feet, please{" "}
          <Link to="/contact-us" className="text-[#FF4311] hover:underline">Contact Us</Link> for a quote.
        </p>

        <div className="mt-10 space-y-8">
          {PACKAGES.map((p) => (
            <article key={p.name} data-testid={`boat-${p.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`} className="bg-[#121216] border border-[#232329] p-7 md:p-10">
              <div className="flex flex-wrap items-baseline justify-between gap-3">
                <h2 className="font-display uppercase text-2xl tracking-wide text-white">{p.name}</h2>
                <p className="font-display text-2xl text-[#FF4311]">{p.price}</p>
              </div>
              <p className="mt-3 text-sm text-slate-300 leading-relaxed">{p.desc}</p>
            </article>
          ))}
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="bg-[#121216] border border-[#232329] p-7">
            <h3 className="font-display uppercase text-xl tracking-wide text-white">Information</h3>
            <p className="mt-3 text-sm text-slate-300 leading-relaxed">
              Prices may vary depending on your boats location, size, style and condition. If the
              boat has not been cleaned in a while, the initial cleaning/detailing price may be
              higher than the above prices. We will look at the condition of the boat and provide
              you with an estimate.
            </p>
            <p className="mt-3 text-sm text-slate-300">
              All boats must be paid in full upon completion of the job.{" "}
              <span className="text-[#FF4311] font-semibold">No exceptions!!!</span>
            </p>
          </div>
          <div className="bg-[#121216] border border-[#232329] p-7">
            <h3 className="font-display uppercase text-xl tracking-wide text-white">How do we determine pricing?</h3>
            <p className="mt-3 text-sm text-slate-300 leading-relaxed">
              For example, if your boat is 24 feet long and requires compound and wax (exterior
              only), this covers 1 pass of compounding and 1 coat of wax. The price will be $17.00
              per foot. But if your boat requires 2 passes of compound, the price goes up. Or if
              your boat has a tall hull (taller than average), the price goes up. Or if we have to
              compound 3 times before to remove deep scratches before we wax, the price goes up even
              more. Our prices listed above are based on average sized boats in good condition.
            </p>
          </div>
        </div>

        <div className="mt-10">
          <BookNowButton to="/schedule" label="Book With Us" testid="boat-book-button" />
        </div>
      </PageBody>
    </PageLayout>
  );
}
